import useWebSocketRaw, { ReadyState } from "react-use-websocket";
import { useCallback, useEffect, useState } from "react";
import ConfigInterface from "../ConfigInterface";

interface DomainAvailability {
  domain: string;
  available: boolean;
  price: {
    price: number;
    transferPrice: number;
  } | null;
}
interface DomainSearchResult {
  result: "success" | "error";
  command: string;
  data: DomainAvailability;
}
export const useDomainSearch = (config: ConfigInterface) => {
  const [results, setResults] = useState<DomainSearchResult[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const useWebSocket = typeof useWebSocketRaw === "function" ? useWebSocketRaw : (useWebSocketRaw as any).default;
  const { sendMessage, lastMessage, readyState } = useWebSocket(config.domainApiUrl);
  const [hasError, setHasError] = useState<string | null>(null);
  useEffect(() => {
    const message = JSON.parse(lastMessage?.data || "{}") as DomainSearchResult;
    if (message.result !== "success") {
      setHasError(JSON.stringify(message.data));
      return;
    }
    setResults((old) => [...old, message]);
  }, [lastMessage]);

  const search = useCallback(
    (domains: string[]) => {
      setResults([]);
      setHasError(null);
      sendMessage(JSON.stringify({ command: "turboSearch", data: { domains } }));
    },
    [sendMessage],
  );

  return {
    search: readyState === ReadyState.OPEN ? search : undefined,
    results,
    error: hasError,
  };
};
